var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"section-contactus"},[_c('div',{staticClass:"footer-title",domProps:{"innerHTML":_vm._s(_vm.getWordings.partnerSectionBecomeTitle)}}),_c('LinkButton',{staticClass:"link-button",attrs:{"wordingKey":'partnerSectionBecomeButton',"hrefLink":_vm.routes.contactUs.url,"isShowIcon":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }